<div>

	<div id='g-USmap-box' class='ai2html'>
		<!-- Generated by ai2html v0.59 - 2016-12-20 - 10:54 -->
		<!-- ai file: USmap -->
		<!-- Artboard: Artboard_1 -->
		<div id='g-USmap-Artboard_1' class='g-artboard ' data-min-width='1505'>
			<div id='g-USmap-Artboard_1-graphic'>
				<img id='g-ai0-0'
					class='g-aiImg all-dots'
					src='<@baseUrl@>/<@version@>/files/images/USmap-Artboard_{{mapNum}}.png'
					/>
				<!-- <img id='g-ai0-0'
					class='g-aiImg city-dots'
					src='<@baseUrl@>/<@version@>/files/images/USmap-Artboard_{{mapNum}}.png'
					/> -->
				<div id='g-ai0-1' class='g-Labels g-aiAbs' style='top:6.1117%;left:10.7253%;'>
					<p class='g-aiPstyle0'>Seattle</p>
				</div>
				<div id='g-ai0-2' class='g-Labels g-aiAbs' style='top:12.6162%;right:86.7283%;'>
					<p class='g-aiPstyle1'>Portland</p>
				</div>
				<div id='g-ai0-3' class='g-Labels g-aiAbs' style='top:23.1871%;right:42.0551%;'>
					<p class='g-aiPstyle1'>Minneapolis</p>
				</div>
				<div id='g-ai0-4' class='g-Labels g-aiAbs' style='top:24.7973%;left:93.8153%;'>
					<p class='g-aiPstyle0'>Boston</p>
				</div>
				<div id='g-ai0-5' class='g-Labels g-aiAbs' style='top:28.3864%;right:33.4533%;'>
					<p class='g-aiPstyle1'>Milwaukee</p>
				</div>
				<div id='g-ai0-6' class='g-Labels g-aiAbs' style='top:29.3653%;left:74.4148%;'>
					<p class='g-aiPstyle0'>Detroit</p>
				</div>
				<div id='g-ai0-7' class='g-Labels g-aiAbs' style='top:31.8368%;left:90.0513%;'>
					<p class='g-aiPstyle0'>New York</p>
				</div>
				<div id='g-ai0-8' class='g-Labels g-aiAbs' style='top:33.6069%;left:77.7274%;'>
					<p class='g-aiPstyle0'>Cleveland</p>
				</div>
				<div id='g-ai0-9' class='g-Labels g-aiAbs' style='top:36.2171%;left:88.671%;'>
					<p class='g-aiPstyle0'>Philadelphia</p>
				</div>
				<div id='g-ai0-10' class='g-Labels g-aiAbs' style='top:35.4347%;right:33.4986%;'>
					<p class='g-aiPstyle1'>Chicago</p>
				</div>
				<div id='g-ai0-11' class='g-Labels g-aiAbs' style='top:37.8485%;right:88.8802%;'>
					<p class='g-aiPstyle1'>Oakland</p>
				</div>
				<div id='g-ai0-12' class='g-Labels g-aiAbs' style='top:37.8485%;right:72.4129%;'>
					<p class='g-aiPstyle1'>Salt Lake City</p>
				</div>
				<div id='g-ai0-13' class='g-Labels g-aiAbs' style='top:39.8712%;left:86.6638%;'>
					<p class='g-aiPstyle0'>Baltimore</p>
				</div>
				<div id='g-ai0-14' class='g-Labels g-aiAbs' style='top:39.5887%;left:66.5221%;'>
					<p class='g-aiPstyle0'>Indianapolis</p>
				</div>
				<div id='g-ai0-15' class='g-Labels g-aiAbs' style='top:42.0026%;right:90.062%;'>
					<p class='g-aiPstyle1'>San Francisco</p>
				</div>
				<div id='g-ai0-16' class='g-Labels g-aiAbs' style='top:41.4376%;right:61.062%;'>
					<p class='g-aiPstyle1'>Denver</p>
				</div>
				<div id='g-ai0-17' class='g-Labels g-aiAbs' style='top:43.069%;left:84.986%;'>
					<p class='g-aiPstyle0'>Washington DC</p>
				</div>
				<div id='g-ai0-18' class='g-Labels g-aiAbs' style='top:44.3742%;left:62.9801%;'>
					<p class='g-aiPstyle0'>St Louis</p>
				</div>
				<div id='g-ai0-19' class='g-Labels g-aiAbs' style='top:48.2545%;left:20.8181%;'>
					<p class='g-aiPstyle0'>Las Vegas</p>
				</div>
				<div id='g-ai0-20' class='g-Labels g-aiAbs' style='top:56.0115%;left:35.705%;'>
					<p class='g-aiPstyle0'>Albuquerque</p>
				</div>
				<div id='g-ai0-21' class='g-Labels g-aiAbs' style='top:58.2955%;right:85.5463%;'>
					<p class='g-aiPstyle1'>Los Angeles</p>
				</div>
				<div id='g-ai0-22' class='g-Labels g-aiAbs' style='top:59.1655%;left:24.5023%;'>
					<p class='g-aiPstyle0'>Phoenix</p>
				</div>
				<div id='g-ai0-23' class='g-Labels g-aiAbs' style='top:63.6882%;left:75.366%;'>
					<p class='g-aiPstyle0'>Atlanta</p>
				</div>
				<div id='g-ai0-24' class='g-Labels g-aiAbs' style='top:61.1232%;left:63.5977%;'>
					<p class='g-aiPstyle0'>Memphis</p>
				</div>
				<div id='g-ai0-25' class='g-Labels g-aiAbs' style='top:66.1262%;left:53.0683%;'>
					<p class='g-aiPstyle0'>Dallas</p>
				</div>
				<div id='g-ai0-26' class='g-Labels g-aiAbs' style='top:79.1774%;left:65.1064%;'>
					<p class='g-aiPstyle0'>New Orleans</p>
				</div>
				<div id='g-ai0-27' class='g-Labels g-aiAbs' style='top:81.9176%;left:54.2387%;'>
					<p class='g-aiPstyle0'>Houston</p>
				</div>
				<div id='g-ai0-28' class='g-Labels g-aiAbs' style='top:89.2921%;left:85.4578%;'>
					<p class='g-aiPstyle0'>Miami</p>
				</div>
			</div>
		</div>
		<!-- End ai2html - 2016-12-20 - 10:54 -->
	</div>

</div>

<style>

.g-artboard {
	margin:0 auto;
}

#g-USmap-Artboard_1{
	position:relative;
	overflow:hidden;
}

.g-aiAbs{
	position:absolute;
}

.g-aiImg{
	display:block;
	width:100% !important;
}

.g-aiPtransformed p { white-space: nowrap; }

.g-aiPstyle0, .g-aiPstyle1 {
	font-size: 14px;
    font-family: 'Guardian Text Sans Web';
    text-shadow: 2px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;

}

.g-aiPstyle0 {
	text-align: left;
}

.g-aiPstyle1 {
	text-align: right;
}

/*.city-dots {
	display: none;
}*/

@media(max-width:870px) {
	#g-ai0-9, #g-ai0-14, #g-ai0-15, #g-ai0-17 {
		display: none;
	}
}

@media(max-width:700px) {
	#g-ai0-2, #g-ai0-3, #g-ai0-4, #g-ai0-5, #g-ai0-12, #g-ai0-20 {
		display: none;
	}
}

@media(max-width:600px) {
	#g-ai0-1, #g-ai0-6, #g-ai0-8, #g-ai0-16, #g-ai0-19, #g-ai0-21, #g-ai0-22, #g-ai0-23, #g-ai0-24, #g-ai0-25, #g-ai0-27, #g-ai0-28    {
		display: none;
	}


	.g-aiPstyle0, .g-aiPstyle1 {
		font-size: 12px;
		line-height: 10px;
	}

}

@media(max-width:450px) {
	.g-aiPstyle0, .g-aiPstyle1  {
		display: none;
	}
}

</style>

<script>


export default {
	data () {
		return {


		}
	}

};
</script>
